import { normalizeNamespaceForRemoval } from './normalize-namespace-for-removal.js'

export function readNamespaceFromConfigSource(source: string): string | undefined {
  const match = source.match(/\bnamespace\s*:\s*(['"`])([^'"`]+)\1/)
  return normalizeNamespaceForRemoval(match?.[2])
}
